module.exports = __webpack_public_path__ + "static/media/Titillium-Bold.228729e0.otf";